<template>
<div class="animated fadeIn">
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-6">
          <b-form inline>
            <label class="mr-sm-2 d-inline">{{$t('ITEMSPERPAGE')}}</label>
            <b-form-select v-model="pagination.limit" :options="[{value: 25, text: '25'},{value: 50, text: '50'},{value: 100, text: '100'}]"></b-form-select>
          </b-form>
        </div>
        <div class="col-sm-6">
          <b-form-input class="col-sm-3 float-right" v-model="pagination.query" :placeholder="$t('SEARCH')"></b-form-input>
        </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('TITLE')}}</th>
                <th>{{$t('ACTION')}}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in response.root">
                <tr aria-rowindex="1" class=" table-ellipsis">
                  <td v-html="item.title"></td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm mr-2" @click="showModal(item.questionFormId)">{{$t('ANSWERQUESTIONFORM')}}</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <nav>
            <b-pagination align="center" :total-rows="parseInt(response.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('QUESTIONFORM')" ok-title="submit" hide-footer size='lg' no-close-on-backdrop>
    <div class="d-block">
      <qestionform v-bind:formData="formData" v-bind:formError="formError"></qestionform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="success" @click="submitData(formData)">{{$t('SUBMIT')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import Api from '@/api/cms/Question'
import QestionForm from './Form'

export default
{
  name: 'Question',
  components:
  {
    qestionform: QestionForm
  },
  data: function()
  {
    return {
      response:
      {},
      formError:
      {},
      formData: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectRow(me.getParams);
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async showModal(item)
    {
      var me = this;

      try
      {
          var data = await Api.selectQuestions({id: item});
          me.formData = data;

          this.$refs.formmodal.show()
      }
      catch (error)
      {
          me.$notify.notice(e);
      }
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        item.googleForm = true;
        var data = await Api.submitAnswers(item);   
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        title: '',
        content: ''
      }
    }
  },
  watch:
  {
        'pagination.limit': function(val)
        {
          var me = this;
          me.getData();
        },
        'pagination.currentPage': function(val)
        {
          var me = this;
          me.getData();
        },
        'pagination.query': function(val)
        {
              var me = this;

              if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

              me.pagination.searchTimeout = setTimeout(function()
              {
                me.getData();
                me.pagination.searchTimeout = false;
              }, 300);
         },
        '$route.params.questionCategoryId': function(val)
        {
          var me = this;
          me.getData();
        }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.questionCategoryId = me.$route.params.questionCategoryId;
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
